module.exports = __webpack_public_path__ + "static/media/S2N12-4.cea45243.svg";